import React, { Component } from 'react';
import PropTypes from 'prop-types';
import { connect } from 'react-redux';
import { bindActionCreators } from 'redux';
import { push } from 'react-router-redux';
import Button from '@material-ui/core/Button';
import Paper from '@material-ui/core/Paper';
import List from '@material-ui/core/List';
import MenuItem from '@material-ui/core/MenuItem';
import ListItemSecondaryAction from '@material-ui/core/ListItemSecondaryAction';
import ListItemText from '@material-ui/core/ListItemText';
import BusinessIcon from '@material-ui/icons/Business';
import ChevronRightIcon from '@material-ui/icons/ChevronRight';
import WarningIcon from '@material-ui/icons/Warning';

import { fetchAccountsRoutine, selectAccountRoutine } from '../../../redux/routines';
import Loading from '../../Common/Loading';
import AddAccountDialog from '../AddAccountDialog';
import { showDialog } from '../../../redux/actions/dialogs';
import AlertDialog from '../../Common/AlertDialog';
import { toJS } from '../../../utils/helper';

import styles from './styles';
import { ADD_ACCOUNT_DIALOG, ALERT_DIALOG } from '../../../redux/constants/dialogs';
import { isDialogVisibleSelector } from '../../../redux/selectors';

class SelectAccount extends Component {
  state = {
    // userInfo: JSON.parse(localStorage.getItem('userInfo')),
  };

  componentWillMount() {
    this.props.fetchAccounts();
  }

  renderAccount = (account) => {
    return (<MenuItem
      key={account.id}
      style={styles.accountItem}
      onClick={() => {
        this.props.onSelectAccount(account);
        this.props.push('/');
      }}
    >
      {account && account.logo ? <img key="logo" alt="Logo" src={account.logo} style={styles.businessLogo}/> :
        <BusinessIcon key="icon" style={styles.businessIcon}/>}
      <ListItemText primary={account.name}/>
      <ListItemSecondaryAction>
        <ChevronRightIcon style={styles.selectIcon}/>
      </ListItemSecondaryAction>
    </MenuItem>);
  };

  renderAccounts() {
    const { accounts } = this.props;
    // console.log('accounts', accounts);

    return (<List
      style={styles.list}
    >
      {(accounts || []).map((account) => this.renderAccount(account))}
    </List>);
  }

  render() {
    const { accounts, showDialog, loading, isDialogVisible } = this.props;

    return (
      <div style={styles.container}>
        <img alt="Logo" src="/images/logo.png"/>

        {!loading && (!accounts || !accounts.length) ? <div style={styles.noAccounts}>
          <WarningIcon style={styles.warningIcon} color="inherit"/>
          You are not associated with any accounts. Please speak with an account administrator or create a new account
        </div> : null}

        <Paper style={styles.paper}>

          {loading ? <Loading/> : null}

          {this.renderAccounts(accounts)}

          <div>
            <Button
              variant="contained"
              type="button"
              color="primary"
              style={styles.register}
              fullWidth
              onClick={() => showDialog(ADD_ACCOUNT_DIALOG)}>
              Create New Account
            </Button>

            <Button
              variant="contained"
              type="button"
              color="secondary"
              style={styles.logout}
              fullWidth
              onClick={() => this.props.push('/logout')}
            >
              Logout
            </Button>

          </div>

        </Paper>

        {isDialogVisible(ADD_ACCOUNT_DIALOG) ? <AddAccountDialog/> : null}
        {isDialogVisible(ALERT_DIALOG) ? <AlertDialog/> : null}
      </div>

    );
  }
}

SelectAccount.propTypes = {
  fetchAccounts: PropTypes.func.isRequired,
  onSelectAccount: PropTypes.func.isRequired,
  push: PropTypes.func.isRequired,
};

function mapStateToProps(state) {
  return {
    loading: state.getIn(['accounts', 'accounts', 'loading']),
    accounts: toJS(state.getIn(['accounts', 'accounts', 'data'])),
    error: state.getIn(['authentication', 'error']) ? state.getIn(['authentication', 'error']).toJS() : null,
    user: state.getIn(['authentication', 'profile']),
    isDialogVisible: isDialogVisibleSelector(state),
  };
}

function mapDispatchToProps(dispatch) {
  return bindActionCreators({
    showDialog,
    fetchAccounts: fetchAccountsRoutine.trigger,
    onSelectAccount: selectAccountRoutine.success,
    push,
  }, dispatch);
}

export default connect(mapStateToProps, mapDispatchToProps)(SelectAccount);



// WEBPACK FOOTER //
// ./src/components/Authentication/SelectAccount/index.js